import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trees, Droplets, Zap, Home as HomeIcon, Route, Sprout, Utensils, Bird, Wrench, Coffee, Hammer, AlertTriangle, FileText } from "lucide-react";

// 2F · Sanctuary field-state surface (Lean-Core Pass 2)
// NOT_YET_CONNECTED — honest reporting per mandate §5.
const DOMAIN_ICON = {
  water: Droplets, sanitation: Droplets, power: Zap,
  structures: HomeIcon, access_paths: Route, cultivation: Sprout,
  food: Utensils, animals: Bird, tools_materials: Wrench,
  hospitality: Coffee, active_projects: Hammer, problems: AlertTriangle,
  evidence: FileText,
};

export default function Sanctuary() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get("/sanctuary").then(r => setData(r.data)).catch(e => setErr(e?.response?.data?.detail || e.message));
  }, []);

  if (err) return <div className="p-8 text-red-700" data-testid="sanctuary-error">Sanctuary view failed: {err}</div>;
  if (!data) return <div className="p-8 text-forest/60" data-testid="sanctuary-loading">Loading Sanctuary…</div>;

  return (
    <div className="space-y-6" data-testid="sanctuary-page">
      <header>
        <div className="overline">Command Surface</div>
        <h1 className="font-serif text-4xl mt-1">Sanctuary</h1>
        <p className="text-ink-soft text-sm">State: <span className="font-medium text-terracotta">{data.state}</span></p>
      </header>

      <section className="bg-admin-surface border border-terracotta/30 rounded-xl p-5" data-testid="sanctuary-note">
        <div className="flex items-start gap-3">
          <AlertTriangle className="h-5 w-5 text-terracotta mt-0.5" strokeWidth={1.5} />
          <div>
            <div className="font-medium text-forest mb-1">Honest state</div>
            <p className="text-sm text-ink">{data.note}</p>
          </div>
        </div>
      </section>

      <section className="bg-admin-surface border border-line rounded-xl overflow-hidden" data-testid="sanctuary-domains">
        <div className="px-5 py-3 border-b border-line bg-bone/40 overline">Field domains · 13</div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 p-5">
          {data.domains.map(d => {
            const Icon = DOMAIN_ICON[d.name] || Trees;
            return (
              <div key={d.name} className="border border-line rounded-lg p-3 flex items-start gap-3 bg-bone/30" data-testid={`sanctuary-domain-${d.name}`}>
                <Icon className="h-4 w-4 text-forest mt-0.5" strokeWidth={1.5} />
                <div className="flex-1">
                  <div className="text-sm font-medium capitalize">{d.name.replace(/_/g, " ")}</div>
                  <div className="text-xs text-ink-soft">{d.state}</div>
                  {d.last_report && <div className="text-[10px] text-ink-soft mt-1">last report {d.last_report}</div>}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="bg-admin-surface border border-line rounded-xl p-5" data-testid="sanctuary-how-to-connect">
        <div className="overline mb-2">How to connect</div>
        <ol className="text-sm space-y-1 list-decimal list-inside text-ink">
          {(data.how_to_connect || []).map((step, i) => <li key={i}>{step}</li>)}
        </ol>
      </section>
    </div>
  );
}
